export default __webpack_public_path__ + "static/media/Icon43.2fab6e63.svg";